module.exports = __webpack_public_path__ + "img/ck.0a3f28d8.png";